import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";

import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function ProductDetailsScreenViewModel(logout, productId, addSnackbar) {
  const [loading, setLoading] = useState(true);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [inventoryTypeOptions, setInventoryTypeOptions] = useState([]);
  const [classTypeOptions, setClassTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [boxTypeOptions, setBoxTypeOptions] = useState([]);
  const [allergenOptions, setAllergenOptions] = useState([]);
  const [graphicsOptions, setGraphicsOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [warehouseLocationsOptions, setWarehouseLocationsOptions] = useState(
    []
  );
  const [product, setProduct] = useState(null);
  const [productColours, setProductColours] = useState([]);
  const [productOdours, setProductOdours] = useState([]);
  const [productTastes, setProductTastes] = useState([]);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getInventoryTypes = async function () {
    let callResult = await makeGetApiCall("inventoryTypesForDropdown");
    if (callResult.success) {
      setInventoryTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getClassTypes = async function () {
    let callResult = await makeGetApiCall("classesForDropdown");
    if (callResult.success) {
      setClassTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch class types");
    }
  };

  const getCategoryTypes = async function () {
    let callResult = await makeGetApiCall("categoriesForDropdown");
    if (callResult.success) {
      setCategoryOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch category types");
    }
  };

  const getBoxTypes = async function () {
    let callResult = await makeGetApiCall("boxTypesForDropdown");
    if (callResult.success) {
      setBoxTypeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch box types");
    }
  };

  const getAllergens = async function () {
    let callResult = await makeGetApiCall("allergensForDropdown");
    if (callResult.success) {
      setAllergenOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch allergens");
    }
  };

  const getWarehouses = async function () {
    let callResult = await makeGetApiCall("warehousesForDropdown");
    if (callResult.success) {
      setWarehouseOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouses");
    }
  };

  const getWarehouseLocations = async function (warehouseId) {
    let callResult = await makeGetApiCall(
      `warehouseLocationsForDropdown/${warehouseId}`
    );
    if (callResult.success) {
      setWarehouseLocationsOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouse locations");
    }
  };

  const getGraphics = async function (warehouseId) {
    setLoading(true);
    let callResult = await makeGetApiCall(`graphicsForDropdown`);
    setLoading(false);
    if (callResult.success) {
      setGraphicsOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch graphics");
    }
  };

  const getProductDetails = async function () {
    setLoading(true);
    let callResult = await makeGetApiCall(`products/${productId}`);

    if (callResult.success) {
      const product = callResult.data;
      if (product.warehouse_location_id > 0) {
        await getWarehouseLocations(product.warehouse_id);
      }

      setProduct(product);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not update product details");
    }
    setLoading(false);
  };

  const updateProduct = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall(
      `products/${productId}/update`,
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product updated",
          SnackbarType.Success
        )
      );
      setProduct(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onDuplicate = async function () {
    let callResult = await makePostApiCall(`products/duplicate/${productId}`);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Product duplicated",
          SnackbarType.Success
        )
      );
      window.location = "/products/" + callResult.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not duplicate product");
    }
  };

  const getProductColours = async function () {
    let callResult = await makeGetApiCall("productColoursForDropdown");
    if (callResult.success) {
      setProductColours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getProductOdours = async function () {
    let callResult = await makeGetApiCall("productOdoursForDropdown");
    if (callResult.success) {
      setProductOdours(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  const getProductTastes = async function () {
    let callResult = await makeGetApiCall("productTastesForDropdown");
    if (callResult.success) {
      setProductTastes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch inventory types");
    }
  };

  return {
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    inventoryTypeOptions,
    getInventoryTypes,
    classTypeOptions,
    categoryOptions,
    boxTypeOptions,
    allergenOptions,
    warehouseOptions,
    warehouseLocationsOptions,
    getClassTypes,
    getCategoryTypes,
    getBoxTypes,
    getAllergens,
    getWarehouses,
    getWarehouseLocations,
    updateProduct,
    product,
    loading,
    getProductDetails,
    graphicsOptions,
    getGraphics,
    onDuplicate,
    getProductColours,
    getProductOdours,
    getProductTastes,
    productColours,
    productOdours,
    productTastes,
  };
}
